import $ from 'jquery';
import Globals from '../helpers/Globals';

const { $body } = Globals;

const Filters = {
    init() {
        if ($('.js-expand-widget').length) {
            $body.on('click', '.js-expand-widget', e => this.toggleWidget(e));
        }
    },

    toggleWidget(e) {
        $(e.currentTarget).parents('.widget').toggleClass('open');
    },
};

export default Filters;
